// eslint-disable-next-line import/no-anonymous-default-export
export default {
  'Animate old photos': 'Animate Old Photos Online',
  'Animate faces in your photos with AI technology, create vivid videos.':
    'Animate faces in your photos with AI technology, create vivid videos.',
  'Upload a photo': 'Upload a photo',
  'please make sure the face in the photos you selected is facing the lens, otherwise it cannot be processed successfully.':
    'Note: please make sure the face in the photos you selected is facing the lens, otherwise it cannot be processed successfully.',
  'Uploaded successfully!': 'Uploaded successfully!',
  'Please select a template below': 'Please select a template below',
  'Choose a GIF': 'Choose a GIF',
  'Use this template': 'Use this template',
  'Verify successfully! You will':
    'Verify successfully! You will receive the video with {{email}} soon.',
  'You will': 'You will receive the video with {{email}} soon.',
  'What you should expect to happen next':
    'What you should expect to happen next:',
  'We will process your photo into a dynamic video.':
    'We will process your photo into a dynamic video.',
  'After processing, we will send the video to your email.':
    'After processing, we will send the video to your email.',
  'You can check the video in your email.':
    'You can check the video in your email.',
  'Your video will be delivered via email':
    'Your video will be delivered via email',
  'It takes 20-30 minutes to synthesize a dynamic video, please be patient. To protect your privacy, the uploaded pictures will be automatically deleted after the processing is over.':
    'It takes 20-30 minutes to synthesize a dynamic video, please be patient. To protect your privacy, the uploaded pictures will be automatically deleted after the processing is over.',
  'Your Email': 'Your Email',
  'Last Name': 'Last Name',
  'First Name': 'First Name',
  'Go back': 'Go back',
  'Invalid email address': 'Invalid email address',
  'Enter verification code': 'Enter verification code',
  'Enter the verification code that we sent to':
    'Enter the verification code that we sent to {{email}}.',
  Resend: 'Resend',
  'Verification code': 'Verification code',
  'Resend after': 'Resend after {{num}}s',
  'The verification code is invalid. You can request a new one.':
    'The verification code is invalid. You can request a new one.',
  'Synthesize Video': 'Synthesize Video',
  Next: 'Next',
  'Too many attempts, please try again later.':
    'Too many attempts, please try again later.',
  'xx people is waitting in front of you to generate image.':
    ' creators ahead of you, please wait...',
  'Animating...': 'Animating...',
  'You are in line...': 'You are in line...',
  'Failed to generate, click to retry.': 'Failed to generate, click to retry.',
  'The processing will be completed soon, are you sure you want to cancel it?':
    'The processing will be completed soon, are you sure you want to cancel it?',
  freeAccountExceed: 'The image size cannot exceed 2MB in free version.',
  freeAccountHD: 'Upgrade to download HD watermark-free images.',
  UpgradeToDownloadAsGIF: 'Upgrade to download video as GIF.',
  UpgradeToUploadLimits: 'Upgrade to unlimited image uploads.',
  DynamicTitle: 'HitPaw Online Animate Old Photos',
  SizeLimit: 'No Image Size Limits',
  UploadLimit: 'Unlimited Image Uploads',
  DownloadNoWaterMark: 'Download HD Image with No Watermark',
  DownloadGIF: 'Download Video as GIF',
  Weekly: 'Weekly',
  Monthly: 'Monthly',
  Yearly: 'Yearly',
  priceWeek: '$3.99',
  priceMonth: '$1.99',
  priceYear: '$0.99',
  Week: 'Week',
  billMonth: '$7.99 Billed Monthly',
  billYear: '$47.99 Billed Annually',
};
